/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package app.bigtincan.dsr
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Shibu Bhattarai <shibu.bhattarai@bigtincan.com>
 */

import { HubFile, Story } from "../../model";

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_REQUEST_SUCCESS = 'SEARCH_REQUEST_SUCCESS';
export const SEARCH_REQUEST_FAIL = 'SEARCH_REQUEST_FAIL';
export const SEARCH_SELECT_FILE = 'SEARCH_SELECT_FILE';
export const SEARCH_CLEAR_SELECTION = 'SEARCH_CLEAR_SELECTION';

export interface SearchState {
    searchProgress: boolean;
    files: HubFile[]
    stories: Story[]
    error?: {
        message: string;
        status: number;
    };
}

export interface SearchRequestAction {
    type: typeof SEARCH_REQUEST;
    term: string;
}

export interface SearchSuccessAction {
    type: typeof SEARCH_REQUEST_SUCCESS;
    payload: (HubFile | Story)[];
}

export interface SearchFailedAction {
    type: typeof SEARCH_REQUEST_FAIL;
    error: {
        message: string;
        status: number;
    };
}


export interface SearchFileSelectAction {
    type: typeof SEARCH_SELECT_FILE;
    fileId: number
}

export type SearchKnownAction =
  | SearchRequestAction
  | SearchSuccessAction
  | SearchFailedAction
  | SearchFileSelectAction;
